import React from 'react';
import { withRouter } from 'react-router-dom';

const defaultLocation = {
  pathname: '/',
  search: '',
  hash: '',
};

const Context = React.createContext(defaultLocation);

export const PageLocation = withRouter(
  //
  function PageLocationComponent({ location, children }) {
    useScrollToTop(location.pathname);
    return <Context.Provider value={location}>{children}</Context.Provider>;
  },
);

export function usePageLocation() {
  return React.useContext(Context);
}

function useScrollToTop(pathname = '/') {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
}
